import { US_COUNTIES, US_STATES } from '@cibo/core'
import { TFunction } from 'i18next'
import { groupBy } from 'ramda'

const findStateName = (fips: string) => US_STATES.find(state => state.fips === fips)?.label
const findStateAbbreviation = (fips: string) =>
  US_STATES.find(state => state.fips === fips)?.abbreviation.toUpperCase()
const findCountyName = (fips: string, t: TFunction) =>
  t('countyName', {
    name: US_COUNTIES.find(county => county.fips === fips)?.label,
    stateAbbrev: findStateAbbreviation(fips.slice(0, 2)),
  })
const findFipsName = (fips: string, t: TFunction) =>
  fips.length === 2 ? findStateName(fips) : findCountyName(fips, t)

export const fipsToName = (rawFips: (string | undefined)[], t: TFunction) => {
  const fips = rawFips.filter(Boolean) as string[]
  if (fips.length < 1) return t('unknown')
  // one area, any type
  if (fips.length === 1) return findFipsName(fips[0], t)
  // two areas, any types
  if (fips.length === 2) return `${findFipsName(fips[0], t)} & ${findFipsName(fips[1], t)}`
  // more than three, all counties
  if (fips.every(fip => fip.length > 2)) {
    const fipStates = fips.map(fip => fip.slice(0, 2))
    const fipStatesObj = groupBy((a: string) => a.slice(0, 2), fips)
    // All counties in the same state
    if (fipStates.every(fip => fip === fipStates[0])) {
      return t('countFipsInState', {
        count: fips.length,
        state: findStateName(fipStates[0]),
      })
    }
    if (Object.keys(fipStatesObj).length < 4) {
      console.log(fipStatesObj, Object.keys(fipStatesObj))
      return t('countiesInList', { val: Object.keys(fipStatesObj).map(fip => findStateName(fip)) })
    }
  }
  if (fips.length === 3) {
    // three fips values, mixed types
    return `${findFipsName(fips[0], t)}, ${findFipsName(fips[1], t)} & ${findFipsName(fips[2], t)}`
  }
  // more than three, mixed types
  return `${findFipsName(fips[0], t)}, ${findFipsName(fips[1], t)} & ${t('countOthers', {
    count: fips.length - 2,
  })}`
}
